import { useCallback } from 'react';
import { Icon, LockKeyholeIcon, useToastController, View } from 'smoothie';

import { LogoutType } from '../types/Auth';

export const useLogoutMessage = () => {
    const toast = useToastController();

    const showLogoutMessage = useCallback((logoutType?: LogoutType) => {
        const icon = (
            <View backgroundColor="$green300" padding={8} borderRadius={4}>
                <Icon icon={LockKeyholeIcon} color="$green1100" />
            </View>
        );

        if (logoutType === LogoutType.LogoutButton) {
            toast.show("You've been successfully signed out", {
                duration: 10000,
                icon,
            });
        }

        if (logoutType === LogoutType.Inactivity) {
            toast.show("You've been signed out due to inactivity", {
                duration: 5 * 60 * 1000, // Show this toast for 5 minutes to give the user context (it can be dismissed manually)
                icon,
            });
        }
    }, []);

    return showLogoutMessage;
};
